import React, { useEffect, useState } from 'react';
import VerificarPermisos from '../Tools/VerificarPermisos'
import MsgUtils from '../Tools/MsgUtils';
import addButton from '../../assets/addButon.png'
import { Document, Page, pdfjs } from 'react-pdf';
import '../css/Pdf.css'
import SinglePage from './SinglePage';
import ProtocoloContenido from './ProtocoloContenido';
import EncuestaRespond from '../Formularios/EncuestaRespond';
import ModalCargando from '../utilsComponentes/ModalCargando';
const server = process.env.REACT_APP_SERVER;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function ProtocoloInicio() {
    const [vista, setVista] = useState(0);
    const [subVista, setSubVista] = useState(0);
    const [protocolos, setProtocolos] = useState([]);
    const [menuProtocolo, setMenuProtocolo] = useState([]);
    const [protocoloSelect, setProtocoloSelect] = useState({});
    const [selectMenu, setSelectMenu] = useState({});
    const [regional, setRegional] = useState('990');
    const [loader, setLoader] = useState(false);
    const [areas, setAreas] = useState([]);
    const [idArea, setIdArea] = useState(-1);
    const [categorias, setCategorias] = useState([]);
    const [idCategoria, setIdCategoria] = useState(-1);
    const formatoFecha = (fecha) => {
        let date = new Date(Date.parse(fecha));
        return `${date.getDate()}/${date.toLocaleString('default', { month: 'long' })}/${date.getFullYear()}`;
    }
    const entrarProtocolo = (protocolo) => {
        setProtocoloSelect(protocolo);
        setMenuProtocolo(protocolo.MENU)
        setVista(1);
    }
    function getImagen(dato) {
        //console.log(dato);
        if (dato.TIPO_INFO === 'IMG') {
            return "fa-solid fa-image";
        } else if (dato.TIPO_INFO === 'IMGNS') {
            return "fa-solid fa-images";
        } else if (dato.TIPO_INFO === 'PDF') {
            return "fa-solid fa-file-pdf"
        } else if (dato.TIPO_INFO === 'DOC') {
            return "fa-solid fa-file-word"
        } else if (dato.TIPO_INFO === 'VID') {
            return "fa-brands fa-youtube"
        } else if (dato.TIPO_INFO === "EXA") {
            return "fa-solid fa-pen-clip"
        } else {
            return "fa-solid fa-caret-down";
        }
    }
    const mostrarContenido = (dato) => {
        if (dato.TIPO_INFO !== 'EXA') {
            setSelectMenu({ ...dato, ...protocoloSelect });
            setSubVista(1);
        } else {
            if (protocoloSelect.ID_ENCUESTA !== null) {
                setSubVista(3);
            }
        }
    }
    function getProtocolos(regio) {
        fetch(`${server}/protocolos/getProtocolos`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: regio, idVersion: -1, idProtocolo: -1, idArea: -1
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoader(false);
                if (data.ok) {
                    setProtocolos(data.ok);
                } else {
                    MsgUtils.msgError(data.error)
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function getCategoriaProtocolo(regio) {
        fetch(`${server}/protocolos/getCategoriaProtocolo`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: regio
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setCategorias(data.ok);
                    getProtocolos(regio);
                } else {
                    MsgUtils.msgError(data.error)
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function funcionBuscar() {
        var input, filter, table, tr, td, i, txtValue;
        input = document.getElementById("buscadorPro");
        filter = input.value.toUpperCase();
        table = document.getElementById("protocolos");
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("td")[2];
            if (td) {
                txtValue = td.textContent || td.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
        }
    }
    useEffect(() => {
        if (vista != 0) {
            setVista(0);
        }
        var regio = JSON.parse(localStorage.getItem("__react_session__")).regional
        setRegional(regional);
        setLoader(true);
        fetch(`${server}/protocolos/getAreas`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: regio
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setAreas(data.ok);
                    getCategoriaProtocolo(regio);
                } else {
                    MsgUtils.msgError(data.error)
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }, [])
    return (
        <div>
            {vista === 0 && <div className='container-fluid'>
                <div className='row row-cols g-1 py-2'>
                    <div className='col' style={{ maxWidth: '200px', minWidth: '200px' }}>
                        <div className='input-group'>
                            <label className='text-dark my-auto mx-2 fw-bold' >Area</label>
                            <select className="form-select form-select-sm btn-secondary "
                                value={idArea} onChange={(e) => { setIdCategoria(-1); setIdArea(e.target.value) }}>
                                <option value={-1}>TODOS</option>
                                {areas.map((item, index) => {
                                    return (
                                        <option key={index} value={item.ID_CATEGORIA}>{item.CATEGORIA}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '200px', minWidth: '200px' }}>
                        <div className='input-group'>
                            <label className='text-dark my-auto mx-2 fw-bold' >Categoria</label>
                            <select className="form-select form-select-sm btn-secondary "
                                value={idCategoria} onChange={(e) => setIdCategoria(e.target.value)}>
                                <option value={-1}>TODOS</option>
                                {categorias.map((item, index) => {
                                    if (idArea == -1 || idArea == item.ID_AREA) {
                                        return (
                                            <option key={index} value={item.ID_CATEGORIA}>{item.NOMBRE}</option>
                                        )
                                    }
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '100px', minWidth: '100px' }}>
                        <button className='btn btn-sm btn-success w-100' onClick={() => { setLoader(true); getProtocolos(regional) }}>
                            <i className="fa-solid fa-rotate-right"></i> Recargar
                        </button>
                    </div>
                    <div className='col' style={{ maxWidth: '250px', minWidth: '250px' }}>
                        <div className="input-group input-group-sm">
                            <input type="text" className="form-control" placeholder="Buscar Protocolo"
                                id='buscadorPro' onChange={() => funcionBuscar()} />
                            <button className='btn btn-sm btn-danger' onClick={() => { document.getElementById('buscadorPro').value = ''; funcionBuscar() }}><i className="fa-solid fa-circle-xmark"></i></button>
                        </div>
                    </div>
                </div>
                <div className='table-responsive'>
                    <table className="table table-sm table-striped table-bordered border-secondary" id='protocolos'>
                        <caption>Lista de protocolos</caption>
                        <thead className='bg-secondary bg-gradient text-light fs-bold'>
                            <tr>
                                <th scope="col">AREA</th>
                                <th scope="col">CATEGORIA</th>
                                <th scope="col">FECHA</th>
                                <th scope="col">PROTOCOLO</th>
                                <th scope="col "></th>
                            </tr>
                        </thead>
                        <tbody>
                            {protocolos.map((item, index) => {
                                if (item.ESTADO === 'A' && (item.ID_AREA.split(':').indexOf("" + idArea) != -1 || idArea == -1) && (item.ID_CATEGORIA == idCategoria || idCategoria == -1)) {
                                    return (
                                        <tr key={index}>
                                            <th scope="row" className="col-1">
                                                <div className='container-fluid fw-bold'>
                                                    {item.AREA.split(':').map((valor, index) => {
                                                        return (
                                                            <div className='badge bg-light text-dark w-100' key={index}>
                                                                {valor}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </th>
                                            <td className='col-1'>{item.CATEGORIA}</td>
                                            <td className='col-1'>{formatoFecha(new Date(item.FECHA))}</td>
                                            <td>{item.DESCRIPCION}</td>
                                            <td className='col-1 text-end'>
                                                <button className='btn btn-sm text-light btn-secondary' onClick={() =>{entrarProtocolo(item)}}>
                                                    <i className="fa-solid fa-book-open-reader"></i> Leer
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                }
                            })}
                        </tbody>
                    </table>
                </div>
            </div>}
            {vista === 1 &&
                <div className='container-fluid'>
                    <div className='row row-cols-1 row-cols-sm-2 g-0'>
                        <div className='col col-sm-2 p-0 m-0'>
                            <ul className="list-group py-sm-4">
                                <div className='container-fluid text-center fw-bold' style={{ fontSize: "20px" }}>{protocoloSelect.DESCRIPCION}</div>
                                {menuProtocolo.map((item, index) => {
                                    if (item.HAYSUBMENU === 0) {
                                        return (
                                            <li className="list-group-item bg-dark bg-gradient " key={index}>
                                                <button className='btn btn-sm text-light fw-bold text-start w-100'
                                                    onClick={() =>{setSubVista(-1); mostrarContenido(item)}}>
                                                    <i className={getImagen(item)}></i> {item.DESCRIPCION}
                                                </button>
                                            </li>
                                        )
                                    } else {
                                        return (
                                            <li className="list-group-item bg-dark bg-gradient" key={index}>
                                                <a className="btn btn-sm w-100 text-light fw-bold text-start" data-bs-toggle="collapse" href={`#${item.DESCRIPCION}`} role="button" aria-expanded="false" aria-controls="collapseExample">
                                                    <i className={getImagen(item)}></i> {item.DESCRIPCION}
                                                </a>
                                                <div className="collapse" id={`${item.DESCRIPCION}`}>
                                                    <ul className="list-group">
                                                        {item.SUBMENU.map((subm, ind) => {
                                                            return (
                                                                <li className="list-group-item bg-secondary bg-gradient m-0 p-0" key={ind}>
                                                                    <button className='btn btn-sm text-light fw-bold text-start w-100'
                                                                        onClick={() =>{setSubVista(-1);mostrarContenido(subm);}}
                                                                    ><i className={getImagen(subm)}></i> {subm.DESCRIPCION}</button>
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                </div>
                                            </li>)
                                    }
                                })}
                                <li className='list-group-item bg-danger bg-gradient '>
                                    <button className='btn btn-sm text-light fw-bold text-start w-100 ' onClick={() => { setVista(0); setSubVista(0) }}>
                                        <i className="fa-solid fa-circle-xmark"></i> VOLVER A PROTOCOLOS
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div className='col col-sm-10 px-sm-4 py-2 py-md-4'>
                            {subVista > 0 && subVista < 2 && <ProtocoloContenido info={selectMenu} regional={regional} subVista={subVista} />}
                            {subVista == 3 && <EncuestaRespond selectFormu={protocoloSelect} soloVer={false} teclado={false} />}
                        </div>
                    </div>
                </div>
            }
            <ModalCargando show={loader} />
        </div>
    )
}

export default ProtocoloInicio
